import { c as _c } from "react/compiler-runtime";
import UserCICAndLevel, { UserCICAndLevelSize } from "@/components/user/utils/UserCICAndLevel";
import UserCICTypeIcon from "@/components/user/utils/user-cic-type/UserCICTypeIcon";
import type { ApiCommunityMemberOverview } from "@/generated/models/ApiCommunityMemberOverview";
import { isEthereumAddress } from "@/helpers/AllowlistToolHelpers";
import { formatLargeNumber, formatNumberWithCommasOrDash, getTimeAgoShort } from "@/helpers/Helpers";
import { ImageScale, getScaledImageUri } from "@/helpers/image.helpers";
import Link from "next/link";
import { Tooltip } from "react-tooltip";
export default function CommunityMembersTableRow(t0) {
  const $ = _c(103);
  const {
    member,
    rank
  } = t0;
  const isNotProfile = isEthereumAddress(member.detail_view_key);
  const isProfile = !isNotProfile;
  const textColorClass = isProfile ? "tw-text-iron-50" : "tw-text-iron-400";
  const path = `/${member.detail_view_key}`;
  let t1;
  if ($[0] !== rank) {
    t1 = <td className="tw-group tw-whitespace-nowrap tw-px-4 tw-py-4 tw-text-sm tw-font-medium tw-text-iron-400 sm:tw-pl-6 sm:tw-text-base">{rank}</td>;
    $[0] = rank;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = `tw-group tw-whitespace-nowrap tw-py-4 tw-pr-4 tw-text-sm tw-font-medium sm:tw-text-base ${textColorClass}`;
  let t3;
  if ($[2] !== member.pfp) {
    t3 = member.pfp && <img src={getScaledImageUri(member.pfp, ImageScale.W_AUTO_H_50)} alt="Network Table Profile Picture" className="tw-mx-auto tw-h-auto tw-max-h-full tw-w-auto tw-max-w-full tw-bg-transparent tw-object-contain" />;
    $[2] = member.pfp;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <div className="tw-h-8 tw-w-8 tw-overflow-hidden tw-rounded-md tw-bg-iron-900 tw-ring-1 tw-ring-white/10"><div className="tw-h-full tw-w-full tw-max-w-full"><div className="tw-flex tw-h-full tw-items-center tw-justify-center tw-text-center">{t3}</div></div></div>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = `tw-max-w-[6rem] tw-truncate sm:tw-max-w-[15rem] ${textColorClass}`;
  const t6 = `tw-no-underline tw-transition tw-duration-300 tw-ease-out group-hover:tw-text-iron-500 group-hover:tw-underline ${textColorClass}`;
  let t7;
  if ($[6] !== member.display || $[7] !== path || $[8] !== t6) {
    t7 = <Link href={path} className={t6}>{member.display}</Link>;
    $[6] = member.display;
    $[7] = path;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t5 || $[11] !== t7) {
    t8 = <div className={t5}>{t7}</div>;
    $[10] = t5;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t4 || $[14] !== t8) {
    t9 = <div className="tw-flex tw-items-center tw-gap-x-4">{t4}{t8}</div>;
    $[13] = t4;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t2 || $[17] !== t9) {
    t10 = <td className={t2}>{t9}</td>;
    $[16] = t2;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  const t11 = `tw-group tw-whitespace-nowrap tw-px-4 tw-py-4 tw-text-center tw-text-sm tw-font-medium sm:tw-px-6 sm:tw-text-base ${isNotProfile ? "tw-opacity-50" : ""}`;
  let t12;
  if ($[19] !== member.level) {
    t12 = <UserCICAndLevel level={member.level} size={UserCICAndLevelSize.LARGE} />;
    $[19] = member.level;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t11 || $[22] !== t12) {
    t13 = <td className={t11}>{t12}</td>;
    $[21] = t11;
    $[22] = t12;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  const t14 = `tw-group tw-whitespace-nowrap tw-px-4 tw-py-4 tw-text-right tw-text-sm tw-font-medium tw-tabular-nums sm:tw-px-6 sm:tw-text-base ${textColorClass}`;
  const t15 = `tdh-tooltip-${member.detail_view_key}`;
  let t16;
  if ($[24] !== member.tdh) {
    t16 = member.tdh === 0 ? "-" : formatLargeNumber(member.tdh);
    $[24] = member.tdh;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== t15 || $[27] !== t16) {
    t17 = <span data-tooltip-id={t15} className="tw-cursor-default">{t16}</span>;
    $[26] = t15;
    $[27] = t16;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  const t18 = `tdh-tooltip-${member.detail_view_key}`;
  let t19;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = {
      backgroundColor: "#1F2937",
      color: "white",
      padding: "8px 12px"
    };
    $[29] = t19;
  } else {
    t19 = $[29];
  }
  let t20;
  if ($[30] !== member.tdh) {
    t20 = formatNumberWithCommasOrDash(member.tdh);
    $[30] = member.tdh;
    $[31] = t20;
  } else {
    t20 = $[31];
  }
  let t21;
  if ($[32] !== t20) {
    t21 = <span>TDH: {t20}</span>;
    $[32] = t20;
    $[33] = t21;
  } else {
    t21 = $[33];
  }
  const t22 = member.tdh_rate > 0 ? "+" : "";
  let t23;
  if ($[34] !== member.tdh_rate) {
    t23 = formatNumberWithCommasOrDash(Math.round(member.tdh_rate));
    $[34] = member.tdh_rate;
    $[35] = t23;
  } else {
    t23 = $[35];
  }
  let t24;
  if ($[36] !== t22 || $[37] !== t23) {
    t24 = <span>TDH Rate: {t22}{t23}</span>;
    $[36] = t22;
    $[37] = t23;
    $[38] = t24;
  } else {
    t24 = $[38];
  }
  let t25;
  if ($[39] !== t21 || $[40] !== t24) {
    t25 = <div className="tw-flex tw-flex-col tw-gap-y-1">{t21}{t24}</div>;
    $[39] = t21;
    $[40] = t24;
    $[41] = t25;
  } else {
    t25 = $[41];
  }
  let t26;
  if ($[42] !== t18 || $[43] !== t25) {
    t26 = <Tooltip id={t18} place="top" style={t19}>{t25}</Tooltip>;
    $[42] = t18;
    $[43] = t25;
    $[44] = t26;
  } else {
    t26 = $[44];
  }
  let t27;
  if ($[45] !== t14 || $[46] !== t17 || $[47] !== t26) {
    t27 = <td className={t14}>{t17}{t26}</td>;
    $[45] = t14;
    $[46] = t17;
    $[47] = t26;
    $[48] = t27;
  } else {
    t27 = $[48];
  }
  const t28 = `tw-group tw-whitespace-nowrap tw-px-4 tw-py-4 tw-text-right tw-text-sm tw-font-medium tw-tabular-nums sm:tw-px-6 sm:tw-text-base ${textColorClass}`;
  const t29 = `xtdh-tooltip-${member.detail_view_key}`;
  let t30;
  if ($[49] !== member.xtdh) {
    t30 = member.xtdh === 0 ? "-" : formatLargeNumber(Math.round(member.xtdh));
    $[49] = member.xtdh;
    $[50] = t30;
  } else {
    t30 = $[50];
  }
  let t31;
  if ($[51] !== t29 || $[52] !== t30) {
    t31 = <span data-tooltip-id={t29} className="tw-cursor-default">{t30}</span>;
    $[51] = t29;
    $[52] = t30;
    $[53] = t31;
  } else {
    t31 = $[53];
  }
  const t32 = `xtdh-tooltip-${member.detail_view_key}`;
  let t33;
  if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = {
      backgroundColor: "#1F2937",
      color: "white",
      padding: "8px 12px"
    };
    $[54] = t33;
  } else {
    t33 = $[54];
  }
  let t34;
  if ($[55] !== member.xtdh) {
    t34 = formatNumberWithCommasOrDash(Math.round(member.xtdh));
    $[55] = member.xtdh;
    $[56] = t34;
  } else {
    t34 = $[56];
  }
  let t35;
  if ($[57] !== t34) {
    t35 = <span>xTDH: {t34}</span>;
    $[57] = t34;
    $[58] = t35;
  } else {
    t35 = $[58];
  }
  const t36 = member.xtdh_rate > 0 ? "+" : "";
  let t37;
  if ($[59] !== member.xtdh_rate) {
    t37 = formatNumberWithCommasOrDash(Math.round(member.xtdh_rate));
    $[59] = member.xtdh_rate;
    $[60] = t37;
  } else {
    t37 = $[60];
  }
  let t38;
  if ($[61] !== t36 || $[62] !== t37) {
    t38 = <span>xTDH Rate: {t36}{t37}</span>;
    $[61] = t36;
    $[62] = t37;
    $[63] = t38;
  } else {
    t38 = $[63];
  }
  let t39;
  if ($[64] !== t35 || $[65] !== t38) {
    t39 = <div className="tw-flex tw-flex-col tw-gap-y-1">{t35}{t38}</div>;
    $[64] = t35;
    $[65] = t38;
    $[66] = t39;
  } else {
    t39 = $[66];
  }
  let t40;
  if ($[67] !== t32 || $[68] !== t39) {
    t40 = <Tooltip id={t32} place="top" style={t33}>{t39}</Tooltip>;
    $[67] = t32;
    $[68] = t39;
    $[69] = t40;
  } else {
    t40 = $[69];
  }
  let t41;
  if ($[70] !== t28 || $[71] !== t31 || $[72] !== t40) {
    t41 = <td className={t28}>{t31}{t40}</td>;
    $[70] = t28;
    $[71] = t31;
    $[72] = t40;
    $[73] = t41;
  } else {
    t41 = $[73];
  }
  const t42 = `tw-group tw-whitespace-nowrap tw-px-4 tw-py-4 tw-text-right tw-text-sm tw-font-medium tw-tabular-nums sm:tw-px-6 sm:tw-text-base ${textColorClass}`;
  let t43;
  if ($[74] !== member.rep) {
    t43 = formatNumberWithCommasOrDash(member.rep);
    $[74] = member.rep;
    $[75] = t43;
  } else {
    t43 = $[75];
  }
  let t44;
  if ($[76] !== t42 || $[77] !== t43) {
    t44 = <td className={t42}>{t43}</td>;
    $[76] = t42;
    $[77] = t43;
    $[78] = t44;
  } else {
    t44 = $[78];
  }
  const t45 = `tw-group tw-whitespace-nowrap tw-px-4 tw-py-4 tw-text-right tw-text-sm tw-font-medium tw-tabular-nums sm:tw-text-base ${textColorClass}`;
  let t46;
  if ($[79] !== member.cic) {
    t46 = formatNumberWithCommasOrDash(member.cic);
    $[79] = member.cic;
    $[80] = t46;
  } else {
    t46 = $[80];
  }
  let t47;
  if ($[81] !== member.cic) {
    t47 = <div className="tw-h-5 tw-w-5"><UserCICTypeIcon cic={member.cic} /></div>;
    $[81] = member.cic;
    $[82] = t47;
  } else {
    t47 = $[82];
  }
  let t48;
  if ($[83] !== t46 || $[84] !== t47) {
    t48 = <div className="tw-flex tw-items-center tw-justify-end tw-gap-x-2">{t46}{t47}</div>;
    $[83] = t46;
    $[84] = t47;
    $[85] = t48;
  } else {
    t48 = $[85];
  }
  let t49;
  if ($[86] !== t45 || $[87] !== t48) {
    t49 = <td className={t45}>{t48}</td>;
    $[86] = t45;
    $[87] = t48;
    $[88] = t49;
  } else {
    t49 = $[88];
  }
  const t50 = `tw-group tw-whitespace-nowrap tw-px-4 tw-py-4 tw-text-sm tw-font-medium sm:tw-pr-6 sm:tw-text-base ${textColorClass}`;
  let t51;
  if ($[89] !== member.last_activity) {
    t51 = member.last_activity && <span>{getTimeAgoShort(member.last_activity, Date.now(), true)} ago</span>;
    $[89] = member.last_activity;
    $[90] = t51;
  } else {
    t51 = $[90];
  }
  let t52;
  if ($[91] !== t50 || $[92] !== t51) {
    t52 = <td className={t50}>{t51}</td>;
    $[91] = t50;
    $[92] = t51;
    $[93] = t52;
  } else {
    t52 = $[93];
  }
  let t53;
  if ($[94] !== t1 || $[95] !== t10 || $[96] !== t13 || $[97] !== t27 || $[98] !== t41 || $[99] !== t44 || $[100] !== t49 || $[101] !== t52) {
    t53 = <tr className="tw-transition tw-duration-300 tw-ease-out even:tw-bg-iron-900">{t1}{t10}{t13}{t27}{t41}{t44}{t49}{t52}</tr>;
    $[94] = t1;
    $[95] = t10;
    $[96] = t13;
    $[97] = t27;
    $[98] = t41;
    $[99] = t44;
    $[100] = t49;
    $[101] = t52;
    $[102] = t53;
  } else {
    t53 = $[102];
  }
  return t53;
}